import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_print_slip_cashout',
    templateUrl: './print_slip_cashout.html',
})
export class PrintSlipCashout implements OnInit {
    public init: boolean;

    constructor(public tournamentsService: TournamentsService) {
        SetLanguage('', '');
    }
    public ngOnInit() {
        SetLanguage('', '');
        if (this.init) {
            return;
        }
        this.init = true;
    }
}
